import { SKETCH_MONO, SKETCH_SANS } from "../common/sketchPalette";

/**
 * The hero sketch: the three layers I work across, drawn on top of each other.
 *
 * Like the demo sketch it exercises @penwell/draw-on's three features: the
 * plates, rail and arrows are strokes that draw themselves, the version pill
 * and the numbered badges are fill-only shapes (so they get a temporary
 * outline before their fill fades in), and every label is <text>.
 *
 * Deliberately laid out vertically rather than as a pipeline, so the hero and
 * the open-source section do not read as the same diagram.
 */

const PLATES = [
  { y: 60, title: "Interface", sub: "Next.js &#183; React &#183; TypeScript" },
  { y: 158, title: "Services", sub: "Node &#183; REST &#183; SSE streaming" },
  { y: 256, title: "Data", sub: "Postgres &#183; Mongo &#183; vectors" },
];

const PLATE_X = 120;
const PLATE_W = 380;
const PLATE_H = 58;
const PLATE_CENTER = PLATE_X + PLATE_W / 2;
const BADGE_X = 96;

const buildPlates = ({ ink, quiet, wash }) =>
  PLATES.map(
    (plate, index) => `
    <rect x="${PLATE_X}" y="${plate.y}" width="${PLATE_W}" height="${PLATE_H}" rx="8" fill="none" stroke="${ink}" stroke-width="1.4" />
    <text x="${PLATE_CENTER}" y="${plate.y + 23}" text-anchor="middle" font-family="${SKETCH_SANS}" font-size="14.5" font-weight="600" fill="${ink}">${plate.title}</text>
    <text x="${PLATE_CENTER}" y="${plate.y + 43}" text-anchor="middle" font-family="${SKETCH_MONO}" font-size="10.5" fill="${quiet}">${plate.sub}</text>

    <circle cx="${BADGE_X}" cy="${plate.y + 29}" r="15" fill="${wash}" />
    <text x="${BADGE_X}" y="${plate.y + 33.5}" text-anchor="middle" font-family="${SKETCH_MONO}" font-size="13" fill="${ink}">${index + 1}</text>`
  ).join("");

const buildArrows = ({ ink }) =>
  PLATES.slice(0, -1)
    .map((plate, index) => {
      const from = plate.y + PLATE_H + 10;
      const to = PLATES[index + 1].y - 6;

      return `
    <path d="M${PLATE_CENTER} ${from} C ${PLATE_CENTER - 4} ${from + 8}, ${PLATE_CENTER + 4} ${to - 8}, ${PLATE_CENTER} ${to - 4}" fill="none" stroke="${ink}" stroke-width="1.4" stroke-linecap="round" />
    <path d="M${PLATE_CENTER - 4} ${to - 8} L${PLATE_CENTER} ${to} L${PLATE_CENTER + 4} ${to - 8}" fill="none" stroke="${ink}" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />`;
    })
    .join("");

export const buildHeroSketch = ({ ink, quiet, accent, accentInk, wash }) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 660 330" role="img" aria-label="Three layers I work across: an interface layer in Next.js, React and TypeScript, a services layer in Node with REST and SSE streaming, and a data layer in Postgres, Mongo and vector search.">
  <rect x="460" y="14" width="160" height="30" rx="15" fill="${wash}" />
  <text x="540" y="34" text-anchor="middle" font-family="${SKETCH_MONO}" font-size="11.5" fill="${accentInk}">shipping since 2021</text>

  <path d="M${BADGE_X} 100 C ${BADGE_X - 2} 160, ${BADGE_X + 2} 230, ${BADGE_X} 285" fill="none" stroke="${quiet}" stroke-width="1" stroke-linecap="round" />

  ${buildPlates({ ink, quiet, wash })}
  ${buildArrows({ ink })}

  <path d="M${PLATE_X} 306 C ${PLATE_X + 60} 302, ${PLATE_X + 200} 310, ${PLATE_X + PLATE_W} 305" fill="none" stroke="${accent}" stroke-width="1.4" stroke-linecap="round" />
</svg>`;

export default buildHeroSketch;
